import {post} from '../request';
function getOssParams() {
  return post('/service/getOssPolicy.action')
}

export default {
  getOssParams
}